import { render, staticRenderFns } from "./ChangeContentFrame.vue?vue&type=template&id=3cbffd2c&scoped=true"
import script from "./ChangeContentFrame.vue?vue&type=script&lang=js"
export * from "./ChangeContentFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbffd2c",
  null
  
)

export default component.exports